// action types for cart slice is declared here

export const ADD_TO_CART = 'cart/addToCart';
export const DELETE_FROM_CART = 'cart/deleteFromCart';
export const INCREASE_QUANTITY = 'cart/increaseQuantity';
export const DECREASE_QUANTITY = 'cart/decreaseQuantity';